<app-hr-page-header
  [heading]="headingBusiness"
  [searchPlaceholder]="'Search businesses'"
  [addButtonText]="'Add Business'"
  [exportButtonText]="'Export'"
  [showFilterIcon]="true"
  [initialSearchQuery]="searchQuery"
  (searchInput)="onSearchInput($event)"
  (addClick)="addBusiness()"
  (exportClick)="exportBusinesses()"
  (filterClick)="openFilterDialog()"
></app-hr-page-header>

<div class="hr-table-container">
  <div class="table-responsive" *ngIf="businesslist && businesslist.length > 0">
    <table class="table" id="emp_expense">
      <thead>
        <tr>
          <!-- <th>ID</th> -->
          <th>Business Name</th>
          <th>Head Name / Code</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cmp of businesslist; let i = index">
          <!-- <td>{{ cmp?.id }}</td> -->
          <td>{{ cmp?.name | titlecase }}</td>
          <td>{{ cmp?.head?.name }} - {{ cmp?.head?.emp_id }}</td>
          <td>
            <span class="action-link" (click)="editBusiness(cmp)">
              Edit
              
              <!-- <img class="arrow-image" src="../../../assets/images/arrows.svg" alt="">
            -->
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data State -->
  <div class="no-data-container" *ngIf="!businesslist || businesslist.length === 0">
    <div class="no-data-content">
      <img src="/assets/images/no-data.svg" alt="No data" class="no-data-icon">
      <p class="no-data-message">No Businesses found</p>
    </div>
  </div>
</div>

<!-- Pagination Controls -->
<!-- <div class="pagination-controls" 
     *ngIf="businesslist && businesslist.length > 0"
     style="margin-top: 16px; display: flex; justify-content: flex-end; align-items: center;">
  <mat-paginator
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="page - 1"
    [pageSizeOptions]="[10]"
    (page)="handlePageChange($event.pageIndex + 1)">
  </mat-paginator>
</div> -->
